export default __webpack_public_path__ + "static/matcha-58665abde7b8aac72abe98f1681d17bb.png";